import { parseAsString, useQueryState } from 'nuqs';
import { useCallback } from 'react';

import { DEFAULT_AGENT_TIME_RANGE } from '../constants';

export function useAgentLogsFilterUrlState() {
  const [pipelineName, setPipelineName] = useQueryState(
    'pipelineName',
    parseAsString.withDefault('')
  );
  const [agentName, setAgentName] = useQueryState(
    'agentName',
    parseAsString.withDefault('')
  );
  const [content, setContent] = useQueryState(
    'content',
    parseAsString.withDefault('')
  );

  const [time, setTime] = useQueryState(
    'time',
    parseAsString.withDefault(DEFAULT_AGENT_TIME_RANGE)
  );
  const [dateFrom, setDateFrom] = useQueryState('dateFrom', parseAsString);
  const [dateTo, setDateTo] = useQueryState('dateTo', parseAsString);

  const clearAllFilters = useCallback(() => {
    setPipelineName('');
    setAgentName('');
    setContent('');
    setTime(DEFAULT_AGENT_TIME_RANGE);
    setDateFrom(null);
    setDateTo(null);
  }, [
    setPipelineName,
    setAgentName,
    setContent,
    setTime,
    setDateFrom,
    setDateTo
  ]);

  return {
    filters: {
      pipelineName,
      agentName,
      content,
      time,
      dateFrom,
      dateTo
    },
    setters: {
      setPipelineName,
      setAgentName,
      setContent,
      setTime,
      setDateFrom,
      setDateTo
    },
    clearAllFilters
  };
}
